module.exports = __webpack_public_path__ + "static/media/lambdabug.5d68efee.jpg";